export function formatCurrency (currency, digits = undefined) {
  if (typeof(digits) === "undefined") {
    digits = 2;
  }
  const prefix = (currency < 0 ? "-$" : "$");
  const amount = Math.abs(currency).toLocaleString(undefined, {maximumFractionDigits: digits, minimumFractionDigits: digits});
  
  return `${prefix}${amount}`;
}

export function roundCurrencyUSD(amount) {
  return Math.round(100 * amount) / 100.0;
}